import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.2rem;
	width: 100%;
	overflow-y: auto;
`;
